import React, { Component } from 'react';
import { Row, Col } from 'react-bootstrap';
//import SplitPane from 'react-split-pane';
import DatedListItem from '../_partials/dated-list-item';
import store from '../store';
import ViewSelect from '../_partials/view-select';
import DevView from '../_partials/dev-view';

export default class Experience extends Component {
  constructor(props) {
    super(props);
    this.state = {
      experience: [],
      human: true,
    };
    this.storeListener = this.storeListener.bind(this);
  }

  async UNSAFE_componentWillMount() {
    const state = store.getState();
    this.setState({ experience: state.experience });

    this.unsubscribeStore = store.subscribe(this.storeListener);
  }

  UNSAFE_componentWillUnmount() {
    this.unsubscribeStore();
  }

  storeListener() {
    const state = store.getState();
    this.setState({ experience: state.experience });
  }

  handleChange(viewState) {
    this.setState({ human: !viewState });
  }

  getExperienceItems(experience) {
    return experience.map(job => {
      return (
        <DatedListItem
          yearStart={job.yearStart}
          yearFinish={job.yearFinish}
          companyName={job.company}
          position={job.roles[0]}
        ></DatedListItem>
      );
    });
  }

  getView() {
    if (this.state.human) {
      return this.getExperienceItems(this.state.experience);
    } else {
      return <DevView data={this.state.experience} />;
    }
  }
  render() {
    return (
      <Row className="portfolio__block" id="experience">
        <Col>
          <h3 className="portfolio__block__heading">experience</h3>
          <div className="portfolio__block__experience">
            <ViewSelect onChange={this.handleChange.bind(this, this.state.human)} />
            <hr></hr>
            {this.getView()}
          </div>
        </Col>
      </Row>
    );
  }
}
